<template>
  <div class="personal-info-container">
    <!-- 标题（仅在初始状态显示） -->
    <div  class="title">面部照片</div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="form-content">
        <!-- 初始状态：显示占位图标 -->
        <div v-if="!uploadedImage && !isCameraMode" class="upload-placeholder" @click="showActionSheet = true">
          <div class="placeholder-icon">
            <img :src="avatarPlaceholder" alt="上传头像" class="avatar-placeholder-img" />
          </div>
          <p class="placeholder-text">点击传/拍摄面部正面照片</p>
        </div>

        <!-- 摄像头拍照区域 -->
        <div v-if="!uploadedImage && isCameraMode" class="camera-container">
          <div class="camera-preview" ref="cameraPreview">
            <video ref="videoElement" autoplay muted playsinline class="camera-video" v-if="!cameraUnavailable"></video>
            <canvas ref="canvasElement" class="hidden-canvas"></canvas>

            <!-- 摄像头加载中 -->
            <div v-if="isCameraLoading" class="camera-loading-overlay">
              <div class="loading-spinner"></div>
              <div class="loading-text">正在启动摄像头...</div>
            </div>

            <!-- 摄像头不可用时的提示 -->
            <div v-if="cameraUnavailable && !isCameraLoading" class="camera-unavailable-overlay">
              <div class="unavailable-content">
                <div class="unavailable-icon">📷</div>
                <p class="unavailable-title">无法使用摄像头</p>
                <p class="unavailable-message">{{ cameraErrorMessage || '浏览器不支持摄像头功能或摄像头被占用' }}</p>
                <button class="upload-fallback-btn" @click="triggerFileSelectFromCamera">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 9H15M9 15H15M12 12V9M12 12V15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span>从相册选择照片</span>
                </button>
              </div>
            </div>

          </div>

          <!-- 拍照提示文字和按钮 - 底部 -->
          <div class="camera-bottom">
            <p class="camera-hint-text" v-if="!cameraUnavailable && isCameraReady">请确保面部清晰可见，避免遮挡</p>
            <button class="capture-btn" @click="capturePhoto" v-if="!cameraUnavailable && isCameraReady">
            <img :src="photograph">
            </button>
          </div>
        </div>
          <!-- 拍照后的预览界面 -->
          <div v-if="uploadedImage" class="camera-container">
              <div class="camera-preview uploaded-preview">
                  <img :src="uploadedImage" alt="拍摄的照片" class="preview-image" />
                  
                  <!-- 图片处理中的加载遮罩 -->
                  <div v-if="isProcessingImage" class="image-processing-overlay">
                    <div class="processing-content">
                      <div class="loading-spinner"></div>
                      <div class="loading-text">正在处理照片...</div>
                    </div>
                  </div>

                  <button class="retake-button" @click="retakePhoto" :disabled="isProcessingImage">
                      <span class="retake-icon">
                        <img :src="restartIcon" alt="restart" />
                      </span>
                      <span class="retake-text">重新拍摄/上传</span>
                  </button>
              </div>

              <div class="bottom-actions">
                  <button class="btn-primary" @click="confirmPhoto" :disabled="isProcessingImage">
                      <div class="button-content" v-if="!isProcessingImage">
                          <span class="btn-icon"><img :src="confirmIcon"></span>
                          <span class="btn-text">确定</span>
                      </div>
                      <div class="loading-content" v-else>
                          <div class="loading-spinner"></div>
                          <div class="loading-text">处理中...</div>
                      </div>
                  </button>
              </div>
          </div>
      </div>
    </div>
    
    <!-- 底部操作面板 -->
    <transition name="slide-up">
      <div v-if="showActionSheet" class="action-sheet-overlay" @click="showActionSheet = false">
        <div class="action-sheet" @click.stop>
          <!-- 上方内容区域（可选，用于显示提示信息） -->
<!--          <div class="action-sheet-top">
            <div class="action-sheet-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#4CAF50" opacity="0.2"/>
                <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#4CAF50" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="12" r="1.5" fill="#4CAF50"/>
              </svg>
            </div>
          </div>-->
          
          <!-- 操作按钮区域 -->
          <div class="action-sheet-content">
            <button class="action-btn action-btn-camera" @click="chooseCamera">
              <svg class="action-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 4H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2"/>
              </svg>
              <span class="action-text">拍照</span>
            </button>
            <button class="action-btn action-btn-upload" @click="triggerFileSelect">
              <svg class="action-icon-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 9H15M9 15H15M12 12V9M12 12V15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span class="action-text">上传照片</span>
            </button>
            <button class="action-btn action-btn-cancel" @click="showActionSheet = false">
              <span class="action-text">取消</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    

    
    <!-- 隐藏的文件输入 - 拍照使用系统相机（前置摄像头） -->
    <input ref="cameraInput" type="file" accept="image/*" capture="user" class="hidden-file" @change="onFileChange" />
    <!-- 隐藏的文件输入 - 上传照片从相册选择 -->
    <input ref="fileInput" type="file" accept="image/*" class="hidden-file" @change="onFileChange" />
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import photograph from '@/assets/images/svg/photograph.svg'
import restartIcon from '@/assets/images/svg/restart.svg'
import avatarPlaceholder from '@/assets/images/avatar.png'
import { StartExploreApi } from '@/api/startExplore'
import { expiredStorage } from '@/utils/expiredStorage'
import confirmIcon from "@/assets/images/svg/confirm.svg";


// 定义 emits
const emit = defineEmits(['next', 'validation-change', 'data-change'])

// 定义 props 来接收前面步骤的数据
const props = defineProps({
  step1Data: {
    type: Object,
    default: () => ({})
  },
  step2Data: {
    type: Object,
    default: () => ({})
  },
  initialData: {
    type: Object,
    default: () => ({})
  }
})

// 响应式数据（支持回填）
const fileInput = ref(null)
const cameraInput = ref(null)
const uploadedImage = ref(
  props.initialData.avatarBase64 || 
  props.initialData.avatarUrl || 
  null
)
const isLoading = ref(false)
const isProcessingImage = ref(false) // 图片处理中（文件读取和base64转换）
const uploadResult = ref(null) // 存储API返回的JSON数据

// 摄像头相关状态
const isCameraMode = ref(false)
const isCameraReady = ref(false)
const isCameraLoading = ref(false)
const cameraUnavailable = ref(false) // 摄像头不可用标志
const cameraErrorMessage = ref('') // 摄像头错误信息
// 底部操作面板状态
const showActionSheet = ref(false)
const capturedImage = ref(null)
const videoElement = ref(null)
const canvasElement = ref(null)
const cameraPreview = ref(null)
const mediaStream = ref(null)
const countdown = ref(0)
const countdownTimer = ref(null)

// 计算属性 - 验证是否可以开始探索
const isFormValid = computed(() => {
  return uploadedImage.value !== null
})

// 监听验证状态变化并通知父组件
watch(isFormValid, (newValue) => {
  nextTick(() => {
    emit('validation-change', newValue)
  })
})

// 监听props变化，更新本地数据
watch(() => props.initialData, (newInitialData) => {
  if (newInitialData) {
    // 优先使用base64数据，如果没有则使用avatarUrl
    if (newInitialData.avatarBase64) {
      uploadedImage.value = newInitialData.avatarBase64
      // 如果有avatarFile，恢复uploadResult
      if (newInitialData.avatarFile) {
        uploadResult.value = {
          file: newInitialData.avatarFile,
          base64: newInitialData.avatarBase64
        }
      } else if (newInitialData.avatarBase64) {
        // 如果没有avatarFile但有base64，尝试从base64重新创建File对象
        try {
          const base64Image = newInitialData.avatarBase64
          const byteCharacters = atob(base64Image.split(',')[1])
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
          uploadResult.value = {
            file: file,
            base64: base64Image
          }
        } catch (e) {
          console.warn('从base64恢复File对象失败:', e)
        }
      }
    } else if (newInitialData.avatarUrl) {
      uploadedImage.value = newInitialData.avatarUrl
      // 如果有avatarFile，恢复uploadResult
      if (newInitialData.avatarFile && newInitialData.avatarBase64) {
        uploadResult.value = {
          file: newInitialData.avatarFile,
          base64: newInitialData.avatarBase64
        }
      }
    }
  }
}, { deep: true })

// 组件挂载后手动触发一次验证状态检查，并恢复uploadResult
onMounted(async () => {
  // 如果initialData中有数据，恢复uploadResult
  if (props.initialData) {
    if (props.initialData.avatarFile && props.initialData.avatarBase64) {
      uploadResult.value = {
        file: props.initialData.avatarFile,
        base64: props.initialData.avatarBase64
      }
    } else if (props.initialData.avatarBase64 && !uploadResult.value) {
      // 如果没有avatarFile但有base64，尝试从base64重新创建File对象
      try {
        const base64Image = props.initialData.avatarBase64
        const byteCharacters = atob(base64Image.split(',')[1])
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
        uploadResult.value = {
          file: file,
          base64: base64Image
        }
      } catch (e) {
        console.warn('从base64恢复File对象失败:', e)
      }
    }
  }
  
  // 初始显示模式选择，不自动开启摄像头
  nextTick(() => {
    emit('validation-change', isFormValid.value)
  })
})

// 检查浏览器是否支持摄像头
const checkCameraSupport = () => {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
}

// 点击"拍照"入口 - 启动网页摄像头
const chooseCamera = async () => {
  showActionSheet.value = false
  isCameraMode.value = true
  cameraUnavailable.value = false
  cameraErrorMessage.value = ''
  
  // 检查浏览器是否支持摄像头
  if (!checkCameraSupport()) {
    console.log('浏览器不支持摄像头功能')
    isCameraLoading.value = false
    cameraUnavailable.value = true
    cameraErrorMessage.value = '浏览器不支持摄像头功能'
    return
  }
  
  isCameraLoading.value = true
  
  try {
    await startCamera()
    console.log('摄像头启动成功')
    cameraUnavailable.value = false
  } catch (error) {
    console.error('摄像头启动失败:', error)
    // 即使失败也保持在拍照界面，但显示错误提示
    cameraUnavailable.value = true
    
    // 根据错误类型设置友好的错误信息
    if (error.name === 'NotAllowedError') {
      cameraErrorMessage.value = '摄像头权限被拒绝，请允许访问摄像头后重试'
    } else if (error.name === 'NotFoundError') {
      cameraErrorMessage.value = '未找到摄像头设备'
    } else if (error.name === 'NotReadableError') {
      cameraErrorMessage.value = '摄像头被其他应用占用'
    } else if (error.name === 'TypeError') {
      cameraErrorMessage.value = '浏览器不支持摄像头功能'
    } else {
      cameraErrorMessage.value = '无法启动摄像头，请使用文件上传功能'
    }
  } finally {
    isCameraLoading.value = false
  }
}

// 从摄像头界面触发文件选择（后备方案）
const triggerFileSelectFromCamera = () => {
  if (fileInput.value) {
    fileInput.value.click()
  }
}

// 拍照（直接拍摄，不需要倒计时）
const capturePhoto = () => {
  if (!videoElement.value || !canvasElement.value || !cameraPreview.value) return
  
  const video = videoElement.value
  const canvas = canvasElement.value
  const context = canvas.getContext('2d')
  const preview = cameraPreview.value
  
  // 获取预览容器的实际宽高比
  const previewRect = preview.getBoundingClientRect()
  const previewAspectRatio = previewRect.width / previewRect.height
  
  // 获取video的实际分辨率
  const videoAspectRatio = video.videoWidth / video.videoHeight
  
  let canvasWidth, canvasHeight, sourceX, sourceY, sourceWidth, sourceHeight
  
  // 根据预览容器的宽高比来裁剪video
  if (videoAspectRatio > previewAspectRatio) {
    // video更宽，需要裁剪左右
    sourceHeight = video.videoHeight
    sourceWidth = video.videoHeight * previewAspectRatio
    sourceX = (video.videoWidth - sourceWidth) / 2
    sourceY = 0
    canvasWidth = sourceWidth
    canvasHeight = sourceHeight
  } else {
    // video更高，需要裁剪上下
    sourceWidth = video.videoWidth
    sourceHeight = video.videoWidth / previewAspectRatio
    sourceX = 0
    sourceY = (video.videoHeight - sourceHeight) / 2
    canvasWidth = sourceWidth
    canvasHeight = sourceHeight
  }
  
  // 设置canvas尺寸与预览容器宽高比一致
  canvas.width = canvasWidth
  canvas.height = canvasHeight
  
  console.log('📸 拍照分辨率:', {
    videoResolution: { width: video.videoWidth, height: video.videoHeight },
    previewAspectRatio: previewAspectRatio,
    canvasResolution: { width: canvas.width, height: canvas.height },
    sourceCrop: { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight }
  })
  
  // 绘制裁剪后的视频帧到canvas
  context.drawImage(
    video,
    sourceX, sourceY, sourceWidth, sourceHeight,
    0, 0, canvasWidth, canvasHeight
  )
  
  // 停止摄像头（立即停止，不等待处理）
  stopCamera()
  isCameraMode.value = false
  
  // 立即使用低质量快速生成预览，让用户立即看到结果
  const quickPreview = canvas.toDataURL('image/jpeg', 0.7)
  uploadedImage.value = quickPreview
  
  // 显示处理中的加载状态
  isProcessingImage.value = true
  
  // 触发验证状态变化（立即显示预览界面）
  emit('validation-change', true)
  
  // 在后台异步生成高质量base64和File对象
  setTimeout(() => {
    try {
      // 生成高质量的base64
      const base64Image = canvas.toDataURL('image/jpeg', 0.92)
      
      // 将base64转换为File对象
      const byteCharacters = atob(base64Image.split(',')[1])
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
      
      // 更新为高质量图片
      uploadedImage.value = base64Image
      
      // 暂存文件
      uploadResult.value = {
        file: file,
        base64: base64Image
      }
      
      // 隐藏处理中的加载状态
      isProcessingImage.value = false
      
      // 触发数据变化事件
      emit('data-change', {
        avatarUrl: base64Image,
        avatarBase64: base64Image,
        avatarFile: file
      })
    } catch (error) {
      console.error('处理拍照结果失败:', error)
      isProcessingImage.value = false
      // 如果处理失败，至少保留快速预览
      if (!uploadResult.value) {
        try {
          const byteCharacters = atob(quickPreview.split(',')[1])
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
          uploadResult.value = {
            file: file,
            base64: quickPreview
          }
          emit('data-change', {
            avatarUrl: quickPreview,
            avatarBase64: quickPreview,
            avatarFile: file
          })
        } catch (e) {
          console.error('使用快速预览也失败:', e)
        }
      }
    }
  }, 0)
}

// 点击"上传照片"入口 - 从相册选择
const triggerFileSelect = () => {
  showActionSheet.value = false
  try {
    if (fileInput.value) {
      fileInput.value.click()
    }
  } catch (e) {
    console.error('打开文件选择器失败:', e)
  }
}

// 处理文件选择（拍照或上传照片）
const onFileChange = async (e) => {
  const file = e.target?.files?.[0]
  if (!file) return
  
  // 如果是从摄像头界面选择文件，关闭摄像头模式
  if (isCameraMode.value) {
    stopCamera()
    isCameraMode.value = false
    cameraUnavailable.value = false
  }
  
  // 立即使用对象URL显示预览，不需要等待文件读取
  const objectUrl = URL.createObjectURL(file)
  uploadedImage.value = objectUrl
  
  // 显示处理中的加载状态
  isProcessingImage.value = true
  
  // 触发验证状态变化（立即显示预览界面）
  emit('validation-change', true)
  
  // 在后台异步读取文件并转换为base64
  const reader = new FileReader()
  reader.onload = () => {
    const base64Image = reader.result
    
    // 释放临时对象URL，使用base64替换
    if (uploadedImage.value === objectUrl) {
      URL.revokeObjectURL(objectUrl)
      uploadedImage.value = base64Image
    } else {
      // 如果已经被其他值替换，只释放URL
      URL.revokeObjectURL(objectUrl)
    }
    
    // 暂存文件，等用户点击"确定"后再上传
    uploadResult.value = {
      file: file,
      base64: base64Image
    }
    
    // 隐藏处理中的加载状态
    isProcessingImage.value = false
    
    // 触发数据变化事件
    emit('data-change', {
      avatarUrl: base64Image,
      avatarBase64: base64Image,
      avatarFile: file
    })
  }
  reader.onerror = () => {
    console.error('文件读取失败')
    // 读取失败时释放对象URL
    URL.revokeObjectURL(objectUrl)
    uploadedImage.value = null
    isProcessingImage.value = false
    emit('validation-change', false)
  }
  reader.readAsDataURL(file)
  
  // 清空input的值，允许重复选择同一文件
  e.target.value = ''
}

// 重新拍摄
const retakePhoto = () => {
  // 如果之前使用的是对象URL，需要释放它
  if (uploadedImage.value && uploadedImage.value.startsWith('blob:')) {
    URL.revokeObjectURL(uploadedImage.value)
  }
  uploadedImage.value = null
  uploadResult.value = null
  isProcessingImage.value = false
  emit('validation-change', false)
}

// 确定照片
const confirmPhoto = () => {
  // 如果uploadResult为空，但uploadedImage存在，尝试重新构建uploadResult
  if (!uploadResult.value && uploadedImage.value) {
    try {
      const base64Image = uploadedImage.value
      // 如果是base64格式
      if (typeof base64Image === 'string' && base64Image.startsWith('data:')) {
        const byteCharacters = atob(base64Image.split(',')[1])
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
        uploadResult.value = {
          file: file,
          base64: base64Image
        }
      } else {
        // 如果是URL，无法重建，提示用户
        console.warn('无法从URL重建File对象，请重新上传照片')
        return
      }
    } catch (e) {
      console.error('重建uploadResult失败:', e)
      return
    }
  }
  
  if (!uploadResult.value) {
    console.warn('没有可用的照片数据')
    return
  }
  
  const { file, base64 } = uploadResult.value
  
  // 调用API上传图片
  uploadPhotoAndProceed(file, base64)
}

// 返回上一步
const goBack = () => {
  emit('back')
}

// 开始倒计时
const startCountdown = () => {
  if (countdown.value > 0) return
  
  // 开始3秒倒计时
  countdown.value = 3
  
  countdownTimer.value = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownTimer.value)
      countdownTimer.value = null
      performCapture()
    }
  }, 1000)
}

// 检查摄像头权限
const checkCameraPermission = async () => {
  try {
    const permission = await navigator.permissions.query({ name: 'camera' })
    console.log('摄像头权限状态:', permission.state)
    return permission.state
  } catch (error) {
    console.log('无法检查权限状态:', error)
    return 'unknown'
  }
}

// 启动摄像头
const startCamera = async () => {
  try {
    // 检查浏览器是否支持
    if (!checkCameraSupport()) {
      throw new Error('Browser does not support camera')
    }
    
    // 检查权限状态
    const permissionState = await checkCameraPermission()
    if (permissionState === 'denied') {
      // 不再显示alert，而是抛出错误让上层处理
      throw new Error('Camera permission denied')
    }
    
    // 使用前置摄像头，高清画质
    let stream
    try {
      console.log('🎥 启动前置摄像头...')
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'user', // 前置摄像头
          width: { ideal: 1920, min: 1280 },
          height: { ideal: 1080, min: 720 },
          frameRate: { ideal: 30 }
        }
      })
      console.log('✅ 摄像头启动成功')
    } catch (error) {
      console.log('⚠️ 高清摄像头启动失败，尝试标清...')
      // 降级到标清
      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'user',
          width: { ideal: 1280, min: 640 },
          height: { ideal: 720, min: 480 }
        }
      })
      console.log('✅ 标清摄像头启动成功')
    }
    
    mediaStream.value = stream
    if (videoElement.value) {
      videoElement.value.srcObject = stream
      videoElement.value.onloadedmetadata = () => {
        isCameraReady.value = true
        
        // 显示实际使用的摄像头分辨率
        const videoTrack = stream.getVideoTracks()[0]
        if (videoTrack) {
          const settings = videoTrack.getSettings()
          console.log('🎥 摄像头实际分辨率:', {
            width: settings.width,
            height: settings.height,
            frameRate: settings.frameRate,
            aspectRatio: settings.aspectRatio
          })
          
          // 检查是否为4K
          if (settings.width >= 3840 && settings.height >= 2160) {
            console.log('✅ 正在使用4K摄像头!')
          } else if (settings.width >= 1920 && settings.height >= 1080) {
            console.log('✅ 正在使用1080p摄像头')
          } else {
            console.log('⚠️ 摄像头分辨率较低:', settings.width + 'x' + settings.height)
          }
        }
      }
    }
  } catch (error) {
    console.error('摄像头访问错误:', error)
    
    // 详细的错误处理
    let errorMessage = '无法访问摄像头'
    
    if (error.name === 'NotAllowedError') {
      errorMessage = '摄像头权限被拒绝，请在浏览器设置中允许摄像头访问'
    } else if (error.name === 'NotFoundError') {
      errorMessage = '未找到摄像头设备，请检查摄像头连接'
    } else if (error.name === 'NotReadableError') {
      errorMessage = '摄像头被其他应用占用，请关闭其他使用摄像头的应用'
    } else if (error.name === 'OverconstrainedError') {
      errorMessage = '摄像头不支持请求的分辨率，尝试使用较低分辨率'
      // 尝试降级到较低分辨率
      try {
        console.log('尝试使用较低分辨率...')
        const fallbackStream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: 'user',
            width: { ideal: 1280, min: 640 },
            height: { ideal: 720, min: 480 }
          }
        })
        mediaStream.value = fallbackStream
        if (videoElement.value) {
          videoElement.value.srcObject = fallbackStream
          videoElement.value.onloadedmetadata = () => {
            isCameraReady.value = true
            console.log('✅ 降级分辨率成功')
          }
        }
        return // 成功获取降级分辨率，直接返回
      } catch (fallbackError) {
        console.error('降级分辨率也失败:', fallbackError)
        errorMessage = '摄像头无法使用，请检查设备或浏览器设置'
      }
    } else if (error.name === 'SecurityError') {
      errorMessage = '安全错误：请确保在HTTPS环境下使用摄像头'
    } else if (error.name === 'TypeError') {
      errorMessage = '浏览器不支持摄像头功能'
    }
    
    console.error('摄像头错误详情:', {
      name: error.name,
      message: error.message,
      constraint: error.constraint
    })
    
    // 不再显示alert，而是抛出错误让上层处理（chooseCamera会处理）
    throw error
  }
}


// 执行实际拍照
const performCapture = () => {
  if (!videoElement.value || !canvasElement.value || !cameraPreview.value) return
  
  const video = videoElement.value
  const canvas = canvasElement.value
  const context = canvas.getContext('2d')
  const preview = cameraPreview.value
  
  // 获取预览容器的实际宽高比
  const previewRect = preview.getBoundingClientRect()
  const previewAspectRatio = previewRect.width / previewRect.height
  
  // 获取video的实际分辨率
  const videoAspectRatio = video.videoWidth / video.videoHeight
  
  let canvasWidth, canvasHeight, sourceX, sourceY, sourceWidth, sourceHeight
  
  // 根据预览容器的宽高比来裁剪video
  if (videoAspectRatio > previewAspectRatio) {
    // video更宽，需要裁剪左右
    sourceHeight = video.videoHeight
    sourceWidth = video.videoHeight * previewAspectRatio
    sourceX = (video.videoWidth - sourceWidth) / 2
    sourceY = 0
    canvasWidth = sourceWidth
    canvasHeight = sourceHeight
  } else {
    // video更高，需要裁剪上下
    sourceWidth = video.videoWidth
    sourceHeight = video.videoWidth / previewAspectRatio
    sourceX = 0
    sourceY = (video.videoHeight - sourceHeight) / 2
    canvasWidth = sourceWidth
    canvasHeight = sourceHeight
  }
  
  // 设置canvas尺寸与预览容器宽高比一致
  canvas.width = canvasWidth
  canvas.height = canvasHeight
  
  console.log('📸 拍照分辨率:', {
    videoResolution: { width: video.videoWidth, height: video.videoHeight },
    previewAspectRatio: previewAspectRatio,
    canvasResolution: { width: canvas.width, height: canvas.height },
    sourceCrop: { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight }
  })
  
  // 绘制裁剪后的视频帧到canvas（保持高质量）
  context.drawImage(
    video,
    sourceX, sourceY, sourceWidth, sourceHeight,
    0, 0, canvasWidth, canvasHeight
  )
  
  // 停止摄像头（立即停止，不等待处理）
  stopCamera()
  isCameraMode.value = false
  
  // 立即使用低质量快速生成预览，让用户立即看到结果
  const quickPreview = canvas.toDataURL('image/jpeg', 0.7)
  uploadedImage.value = quickPreview
  
  // 显示处理中的加载状态
  isProcessingImage.value = true
  
  // 触发验证状态变化（立即显示预览界面）
  emit('validation-change', true)
  
  // 在后台异步生成高质量base64和File对象
  setTimeout(() => {
    try {
      // 生成高质量的base64（适合4K）
      const base64Image = canvas.toDataURL('image/jpeg', 0.95)
      
      // 将base64转换为File对象
      const byteCharacters = atob(base64Image.split(',')[1])
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
      
      // 更新为高质量图片
      uploadedImage.value = base64Image
      
      // 暂存文件
      uploadResult.value = {
        file: file,
        base64: base64Image
      }
      
      // 隐藏处理中的加载状态
      isProcessingImage.value = false
      
      // 触发数据变化事件
      emit('data-change', {
        avatarUrl: base64Image,
        avatarBase64: base64Image,
        avatarFile: file
      })
    } catch (error) {
      console.error('处理拍照结果失败:', error)
      isProcessingImage.value = false
      // 如果处理失败，至少保留快速预览
      if (!uploadResult.value) {
        try {
          const byteCharacters = atob(quickPreview.split(',')[1])
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const file = new File([byteArray], 'camera-photo.jpg', { type: 'image/jpeg' })
          uploadResult.value = {
            file: file,
            base64: quickPreview
          }
          emit('data-change', {
            avatarUrl: quickPreview,
            avatarBase64: quickPreview,
            avatarFile: file
          })
        } catch (e) {
          console.error('使用快速预览也失败:', e)
        }
      }
    }
  }, 0)
}

// 上传图片并处理结果
const uploadPhotoAndProceed = (file, base64Image) => {
  // 立即跳转到下一步，不等待API完成
  console.log('拍照完成，立即跳转到下一步')
  // 在跳转前清理摄像头
  stopCamera()
  isCameraMode.value = false
  capturedImage.value = null
  
  // 确保数据已准备好
  if (!uploadResult.value && uploadedImage.value) {
    uploadResult.value = {
      file: file,
      base64: base64Image
    }
  }
  
  // 立即跳转
  emit('next', {
    avatarUrl: uploadedImage.value,
    avatarBase64: base64Image,
    avatarFile: file,
    uploadResult: uploadResult.value // 传递可能已完成的API结果，或null
  })
  
  // 在后台异步执行API请求（不阻塞跳转）
  ;(async () => {
    try {
      console.log('后台开始上传图片到API...')
      console.log('文件信息:', {
        name: file.name,
        size: file.size,
        type: file.type
      })
      
      // 构建身体描述（从前面步骤的数据中获取）
      const bodyDescription = `${props.step2Data.height || 170}cm, ${props.step2Data.weight || 60}kg`
      console.log('身体描述:', bodyDescription)
      console.log('Step2数据:', props.step2Data)
      
      // 调用API上传图片
      const result = await StartExploreApi.analyzeOutfit({
        face_image: file,
        // body_description: bodyDescription // 添加body_description参数
      })
      // console.log('后台API返回数据内容:', JSON.stringify(result, null, 2))
      
      // 保存API返回的JSON数据
      uploadResult.value = result
      
      // 保存数据到localStorage
      try {
        const dataToStore = {
          uploadResult: result
        }
        expiredStorage.setItem('agent-form-step44', dataToStore)
        console.log('拍照API数据已保存到localStorage:', dataToStore)
      } catch (e) {
        console.warn('保存拍照数据到localStorage失败:', e)
      }
      
      // 将结果传递给父组件
      const dataToEmit = {
        avatarUrl: uploadedImage.value,
        avatarBase64: base64Image,
        avatarFile: file,
        uploadResult: result
      }
      console.log('后台发送data-change事件，数据:', dataToEmit)
      emit('data-change', dataToEmit)
      
    } catch (error) {
      console.error('后台API上传失败:', error)
      
      // API失败，保存数据到localStorage
      try {
        const dataToStore = {
          uploadResult: null
        }
        expiredStorage.setItem('agent-form-step44', dataToStore)
        console.log('拍照失败数据已保存到localStorage:', dataToStore)
      } catch (e) {
        console.warn('保存拍照失败数据到localStorage失败:', e)
      }
    }
  })()
}

// 停止摄像头
const stopCamera = () => {
  if (mediaStream.value) {
    mediaStream.value.getTracks().forEach(track => track.stop())
    mediaStream.value = null
  }
  isCameraReady.value = false
}

// 进入下一步（不提交API）
const goToNextStep = () => {
  if (!isFormValid.value) return
  
  // 只保存数据，不调用API
  const stepData = {
    avatarUrl: uploadedImage.value
  }
  
  // 如果当前FormContainer中有base64数据，也要传递
  if (props.initialData.avatarBase64) {
    stepData.avatarBase64 = props.initialData.avatarBase64
  }
  
  // 如果有File对象，也要传递
  if (props.initialData.avatarFile) {
    stepData.avatarFile = props.initialData.avatarFile
  }
  
  emit('next', stepData)
}

// 暴露方法给父组件调用
defineExpose({
  handleSubmit: goToNextStep
})

// 清理资源
onBeforeUnmount(() => {
  // 释放对象URL，避免内存泄漏
  if (uploadedImage.value && uploadedImage.value.startsWith('blob:')) {
    URL.revokeObjectURL(uploadedImage.value)
  }
  // 清理摄像头资源
  stopCamera()
  // 清理倒计时
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
    countdownTimer.value = null
  }
})
</script>

<style scoped>
/* 主容器 */
.personal-info-container {
    width: 100vw;
    height: 100dvh; /* 动态视口高度，更适合移动端 */
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    /*justify-content: center;*/
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;

}

/* 标题样式 */
.title {
    color: rgba(255, 255, 255, 0.95);
    font-size: 24px;
    margin-top: 10%;
    margin-bottom: 30px;
    font-weight: 1000;
    letter-spacing: 0.5px;
    line-height: 1.2;
    text-align: center;
    flex-shrink: 0;
}

/* 主要内容区域 */
.main-content {
    /*width: calc(100% - 32px);*/
    max-width: 420px;
    flex: 1;
    height: auto;
    max-height: calc(100dvh - 120px);
    padding: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}
.upload-placeholder::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 1px;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

/* 表单内容区域 */
.form-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: none;
  width: 100%;
  margin: 0;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
}

/* 占位图标区域 */
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 320px;
  height: 400px;
  border-radius: 24px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  position: relative;
    background: #0b0b0c;
  overflow: hidden;
}

.main-content::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 24px;
  padding: 1px;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.15), 
    rgba(204, 204, 204, 0.1), 
    rgba(204, 204, 204, 0.05), 
    rgba(204, 204, 204, 0.05), 
    rgba(204, 204, 204, 0.1), 
    rgba(255, 255, 255, 0.15));
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.placeholder-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.avatar-placeholder-img {
  /*width: 180px;*/
  /*height: 180px;*/
  object-fit: contain;
  filter: drop-shadow(0 8px 24px rgba(166, 245, 93, 0.2));
  transition: filter 0.3s ease;
}

.upload-placeholder:hover .avatar-placeholder-img {
  filter: drop-shadow(0 8px 24px rgba(166, 245, 93, 0.4));
}

.placeholder-text {
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin: 0;
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
}

.upload-placeholder:hover .placeholder-text {
  color: rgba(255, 255, 255, 0.9);
}

/* 底部操作面板 */
.action-sheet-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.action-sheet {
  width: 100%;
  max-width: 500px;
  background: rgba(40, 40, 40, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 24px 24px 0 0;
  padding: 0;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.6);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.action-sheet-top {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px 24px;
  background: rgba(35, 35, 35, 0.95);
}

.action-sheet-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.15);
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0);
  }
}

.action-sheet-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 0 calc(16px + env(safe-area-inset-bottom, 0px)) 0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  background: rgba(50, 50, 50, 0.95);
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.25s ease;
  width: 100%;
  position: relative;
  color: rgba(255, 255, 255, 0.95);
  font-size: 17px;
  font-weight: 500;
}

.action-btn:not(.action-btn-cancel):not(:last-of-type)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 24px;
  right: 24px;
  height: 0.5px;
  background: rgba(255, 255, 255, 0.08);
}

.action-btn:active {
  background: rgba(60, 60, 60, 0.95);
  transform: scale(0.98);
}


.action-btn-camera .action-icon-svg {
  color: #A6F55D; /* 主题绿色 */
  flex-shrink: 0;
}


.action-btn-upload .action-icon-svg {
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
}

.action-btn-cancel {
  margin-top: 8px;
  border-radius: 0 0 24px 24px;
  background: rgba(55, 55, 55, 0.95);
  font-weight: 400;
}

.action-btn-cancel:active {
  background: rgba(65, 65, 65, 0.95);
}

.action-icon-svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.action-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 17px;
  font-weight: 500;
  flex: 1;
  text-align: left;
}

/* 滑入动画 */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
}

.slide-up-enter-from .action-sheet,
.slide-up-leave-to .action-sheet {
  transform: translateY(100%);
}

.slide-up-enter-to .action-sheet,
.slide-up-leave-from .action-sheet {
  transform: translateY(0);
}

.hidden-file { display: none; }

/* 拍照后的预览界面 */
.photo-preview-container {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
}

.preview-title {
  color: rgba(255, 255, 255, 0.95);
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  padding: 30px 0 20px;
  text-align: center;
  width: 100%;
  flex-shrink: 0;
}

.preview-image-wrapper {
  position: relative;
  width: calc(100% - 32px);
  max-width: 500px;
  /*flex: 1;*/
  height: 70%;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  background: #000;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}

.preview-bottom-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px calc(30px + env(safe-area-inset-bottom, 0px));
  flex-shrink: 0;
}

.retake-button {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(180deg, rgba(20, 20, 22, 0.55), rgba(20, 20, 22, 0.35));
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50px;
  color: rgba(255, 255, 255, 0.96);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(12px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  z-index: 10;
}

.retake-button:hover {
  background: linear-gradient(180deg, rgba(20, 20, 22, 0.65), rgba(20, 20, 22, 0.45));
  transform: translateX(-50%) translateY(-1px);
}

.retake-button:active {
  transform: translateX(-50%) scale(0.95);
}

.retake-icon {
  font-size: 16px;
}

.retake-text {
  letter-spacing: 0.3px;
}

/* 一行胶囊样式，图标+文字不换行 */
.retake-button {
  height: 40px;
  padding: 10px 16px;
  white-space: nowrap;
}
.retake-icon img { width: 16px; height: 16px; display: block; }

/* 统一到底部操作条（与 Step4Mobile 对齐） */
.bottom-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 5%;
  padding: 12px 20px calc(12px + env(safe-area-inset-bottom, 0px));
  display: flex;
  gap: 12px;
  justify-content: space-between;

  z-index: 100;
  pointer-events: none;
}

.bottom-actions > * { pointer-events: auto; }

.btn-primary {
  /*flex: 1;*/
    width: 50%;
    margin: 0 auto;
  height: 48px;
  border-radius: 24px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #A6F55D;
  color: #111;
  box-shadow: 0 4px 16px rgba(166, 245, 93, 0.3);
}

.btn-primary:hover { background: #95E04C; }
.btn-primary:active { transform: scale(0.98); }

.btn-icon { font-size: 18px; font-weight: 600; }
.btn-text { font-size: 16px; font-weight: 600; }
.button-content { display: flex; align-items: center; gap: 8px; }

.preview-bottom-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 90vw;
}

.preview-btn-secondary,
.preview-btn-primary {
  flex: 1;
  height: 48px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.preview-btn-secondary {
  background: rgba(70, 70, 70, 0.9);
  color: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.preview-btn-secondary:hover {
  background: rgba(80, 80, 80, 0.95);
}

.preview-btn-secondary:active {
  transform: scale(0.98);
}

.preview-btn-primary {
  background: #A6F55D;
  color: #000;
  box-shadow: 0 2px 8px rgba(166, 245, 93, 0.3);
  font-weight: 600;
}

.preview-btn-primary:hover {
  background: #95E04C;
}

.preview-btn-primary:active {
  transform: scale(0.98);
}

.btn-icon {
  font-size: 16px;
  font-weight: 400;
}

/* 图片上传区域 */
.upload-box { 
  width: 200px; 
  height: 200px; 
  border-radius: 12px; 
  background: rgba(0,0,0,.25); 
  border: 2px solid rgba(255,255,255,.15); 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  gap: 10px; 
  cursor: pointer; 
  position: relative; 
  overflow: hidden;
  transition: all 0.3s ease;
}

.upload-box:hover {
  border-color: rgba(76, 175, 80, 0.5);
  background: rgba(0,0,0,.35);
}

.upload-bg { 
  position: absolute; 
  left: 0; 
  top: 0; 
  width: 100%; 
  height: 100%; 
  background: rgba(0,0,0,.3); 
  opacity: 0; 
  transition: opacity .25s ease; 
  z-index: 1; 
}

.upload-box:hover .upload-bg { 
  opacity: 1; 
}

.upload-figure { 
  width: 60px; 
  height: 60px; 
  position: relative; 
  z-index: 2;
  opacity: 0.8;
}

.upload-overlay { 
  position: absolute; 
  left: 50%; 
  top: 50%; 
  transform: translate(-50%, -50%); 
  width: 60px; 
  height: 60px; 
  border-radius: 8px; 
  display: none; 
  opacity: 0.9; 
  z-index: 3; 
  object-fit: contain; 
}

.upload-box:hover .upload-overlay { 
  display: block; 
  opacity: 1; 
}

.upload-box:hover .upload-text {
  color: rgba(76, 175, 80, 1);
}

.upload-full { 
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  display: block;
  border-radius: 10px;
}

.upload-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  opacity: .85;
  position: relative;
  z-index: 2;
}

.hidden-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* 加载状态样式 */
.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid rgba(166, 245, 93, 1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 竖屏时优化加载动画 */
@media (orientation: portrait) {
  .loading-content {
    gap: 25px !important;
    padding: 20px !important;
  }
  
  .loading-spinner {
    width: 50px !important;
    height: 50px !important;
    border: 4px solid rgba(255, 255, 255, 0.3) !important;
    border-top: 4px solid rgba(166, 245, 93, 1) !important;
    animation: spin-mobile 1s linear infinite !important;
    -webkit-animation: spin-mobile 1s linear infinite !important;
    transform: translateZ(0); /* 启用硬件加速 */
    -webkit-transform: translateZ(0);
    will-change: transform; /* 提示浏览器优化 */
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  
  .loading-text {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: rgba(255, 255, 255, 1) !important;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5) !important;
    letter-spacing: 0.5px !important;
  }
  
  /* 确保加载容器在竖屏时可见 */
  .take-photo-overlay {
    background: linear-gradient(135deg, 
      rgba(0, 0, 0, 0.6) 0%, 
      rgba(20, 20, 30, 0.8) 50%,
      rgba(0, 0, 0, 0.6) 100%) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
  }
}

/* 移动端专用旋转动画 */
@keyframes spin-mobile {
  0% { 
    transform: rotate(0deg) translateZ(0); 
    -webkit-transform: rotate(0deg) translateZ(0);
  }
  100% { 
    transform: rotate(360deg) translateZ(0); 
    -webkit-transform: rotate(360deg) translateZ(0);
  }
}

/* 拍照指导文字样式 */
.photo-instructions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  max-width: 700px;
}

.instruction-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 26px;
  font-weight: 1000;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.countdown-highlight {
  color: rgba(166, 245, 93, 1);
  font-weight: 700;
  font-size: 26px;
  text-shadow: 0 0 8px rgba(166, 245, 93, 0.5);
}

/* Take Photo按钮覆盖层样式 */
.take-photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.4) 0%, 
    rgba(20, 20, 30, 0.6) 50%,
    rgba(0, 0, 0, 0.4) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  border-radius: 16px;
  backdrop-filter: blur(8px);
}

.take-photo-btn {
    margin-top:10%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: rgba(255,255,255,0.4);
  color: rgba(255, 255, 255, 0.98);
  border: none;
  border-radius: 25px;
  font-size: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(15px);
  box-shadow:
    0 8px 25px rgba(0, 0, 0, 0.3),
    0 4px 12px rgba(0, 0, 0, 0.2);
  justify-content: center;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
  height: 66px;
}

.take-photo-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 
    0 12px 35px rgba(0, 0, 0, 0.4),
    0 6px 16px rgba(0, 0, 0, 0.3);
}
.take-photo-btn::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(178, 178, 178, 0.8),
    rgba(178, 178, 178, 0.4),
    rgba(178, 178, 178, 0.4),
    rgba(178, 178, 178, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 25px;
    padding: 2px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

.take-photo-icon {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.take-photo-icon img {
  width: 27px;
  height: 34px;
  object-fit: contain;
}

.take-photo-text {
  font-size: 26px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 已上传图片容器样式 */
.uploaded-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: 100%;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.retake-btn {
  padding: 12px 24px;
  background: rgba(166, 245, 93, 0.9);
  color: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.retake-btn:hover {
  background: rgba(166, 245, 93, 1);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* 摄像头容器样式 - 新UI */
.camera-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0;

}

.camera-title {
    color: rgba(255, 255, 255, 0.95);
    font-size: 24px;
    margin-top: 10%;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 1.2;
    text-align: center;
    flex-shrink: 0;
}

.camera-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 10;
}

/* 摄像头不可用时的提示界面 */
.camera-unavailable-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  z-index: 10;
  padding: 20px;
  border-radius: 20px;
}

.unavailable-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;
  max-width: 300px;
}

.unavailable-icon {
  font-size: 64px;
  opacity: 0.8;
  margin-bottom: 10px;
}

.unavailable-title {
  color: rgba(255, 255, 255, 0.95);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.unavailable-message {
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.upload-fallback-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: rgba(166, 245, 93, 0.9);
  color: #111;
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  box-shadow: 0 4px 12px rgba(166, 245, 93, 0.3);
}

.upload-fallback-btn:hover {
  background: rgba(166, 245, 93, 1);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(166, 245, 93, 0.4);
}

.upload-fallback-btn:active {
  transform: translateY(0);
}

.upload-fallback-btn svg {
  flex-shrink: 0;
}

/* 底部区域 - 提示文字 + 拍照按钮 */
.camera-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 16px 20px calc(16px + env(safe-area-inset-bottom, 0px));
  /*background: rgba(0, 0, 0, 0.6);*/
  /*backdrop-filter: blur(10px);*/
  flex-shrink: 0;
}

.camera-hint-text {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  margin: 0;
  text-align: center;
  letter-spacing: 0.3px;
}

.capture-btn {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(100, 100, 100, 0.8);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.capture-btn:hover {
  background: rgba(120, 120, 120, 0.9);
  transform: scale(1.05);
}

.capture-btn:active {
  transform: scale(0.95);
}

.capture-btn svg {
  pointer-events: none;
}

/* === 旧样式已清理 === */

.camera-preview {
  position: relative;
  width: calc(100% - 32px);
  max-width: 500px;
  height: 58vh;
  max-height: 65%;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

/* 上传后预览限定高度，避免过长 */
/* 图片处理中的加载遮罩 */
.image-processing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 10;
  border-radius: 24px;
}

.processing-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.processing-content .loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid rgba(166, 245, 93, 1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.processing-content .loading-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 15px;
  font-weight: 500;
}

.uploaded-preview {
  height: 58vh;
  max-height: 65%;
  background: #fff;
  position: relative;
  overflow: hidden;
  border-radius: 24px;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  /* 4K视频渲染优化 */
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: high-quality;
  /* 硬件加速 */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  perspective: 1000;
  /* 4K视频质量优化 */
  -webkit-filter: contrast(1.1) brightness(1.05) saturate(1.1);
  filter: contrast(1.1) brightness(1.05) saturate(1.1);
  /* 抗锯齿 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hidden-canvas {
  display: none;
}

/* 倒计时覆盖层样式 */
.countdown-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  pointer-events: none;
}

.countdown-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
  margin-bottom: 8px;
}

/* 倒计时圆形背景 */
.countdown-circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 
    0 0 40px rgba(0, 0, 0, 0.3),
    inset 0 0 20px rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.countdown-number {
  color: rgba(166, 245, 93, 1);
  font-size: 100px;
  font-weight: 900;
  text-align: center;
  text-shadow: 0 0 30px rgba(166, 245, 93, 0.8);
  animation: countdownPulse 1s ease-in-out infinite;
  line-height: 1;
  font-family: 'Arial', sans-serif;
}

.countdown-instruction {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  text-align: center;
  max-width: 200px;
  line-height: 1.3;
  margin-top: 8px;
}

@keyframes countdownPulse {
  0% {
    transform: scale(1);
    opacity: 1;
    text-shadow: 0 0 30px rgba(166, 245, 93, 0.8);
  }
  50% {
    transform: scale(1.1);
    opacity: 0.9;
    text-shadow: 0 0 40px rgba(166, 245, 93, 1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
    text-shadow: 0 0 30px rgba(166, 245, 93, 0.8);
  }
}

.camera-controls {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  gap: 20px;
  width: auto;
  z-index: 1001;
}

.camera-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  /*border: 2px solid rgba(255, 255, 255, 0.2);*/
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
}

.camera-btn:hover:not(:disabled) {
  border-color: rgba(76, 175, 80, 0.6);
  background: rgba(76, 175, 80, 0.1);
  transform: translateY(-1px);
}

.camera-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.capture-btn:hover:not(:disabled) {
  border-color: rgba(76, 175, 80, 0.8);
  background: rgba(76, 175, 80, 0.2);
}

.cancel-btn:hover:not(:disabled) {
  border-color: rgba(255, 99, 99, 0.6);
  background: rgba(255, 99, 99, 0.1);
}

.capture-icon, .cancel-icon {
  font-size: 20px;
}

.capture-text, .cancel-text {
  font-size: 12px;
  font-weight: 500;
}

/* 拍照预览样式 */
.capture-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 400px;
}

.preview-image {
  /*width: 300px;*/
  /*height: 300px;*/
  object-fit: cover;
  border-radius: 12px;
  /*border: 2px solid rgba(255, 255, 255, 0.2);*/
}

.preview-controls {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.preview-btn {
  padding: 10px 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  min-width: 80px;
}

.preview-btn:hover {
  transform: translateY(-1px);
}

.retake-btn:hover {
  border-color: rgba(255, 193, 7, 0.6);
  background: rgba(255, 193, 7, 0.1);
}

.confirm-btn:hover {
  border-color: rgba(76, 175, 80, 0.6);
  background: rgba(76, 175, 80, 0.1);
}

/* 开始探索按钮 */
.cta {
  margin-top: 20px;
  padding: 12px 36px;
  border-radius: 24px;
  background: rgba(76, 175, 80, 0.9);
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.cta:hover:not(:disabled) {
  background: rgba(76, 175, 80, 1);
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.cta:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.cta:active:not(:disabled) {
  transform: scale(0.95);
}
</style>